// js
import consts from '../utils/consts';
import apiFetch from './api';

// constants
const { baseUrl } = consts;

// api
async function UploadFile(file: Blob): Promise<string> {
    try {
        const body = new FormData();
        body.append('file', file);
        const method = 'POST';
        const configs = {
            method,
            body,
        };
        const response = await apiFetch(`${baseUrl}/uploads`, configs);
        const json = await response.json();
        return json?.file || '';
    } catch (error) {
        // FIXME - Adicionar modal de exibição de avisos.

        alert('Ocorreu um erro em nosso servidor. Tenta novamente mais tarde.');
        return '';
    }
}

export default {
    UploadFile,
};
